import { Directive } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { combineLatest, map, Observable } from 'rxjs';
import {
  IContract,
  MasterdataChangeType,
  MasterDataChangeRequestErrorMessages,
  WhitelabelImage,
} from '../../models';
import { getContractErrors } from '../../utils';
import { getContracts, getSendMasterDataChangeRequestResponse } from '../../+state';

@Directive()
export class UserEditErrorPageBaseComponent {
  public headerTitle = 'user_edit_error_heading';
  public whitelabelImage = WhitelabelImage;
  public changeType: string;
  public errorMsgKeys$: Observable<string[]>;
  public contracts$: Observable<IContract[]>;

  protected readonly MasterdataChangeType = MasterdataChangeType;

  constructor(
    protected store: Store,
    protected translateService: TranslateService
  ) {
    this.contracts$ = this.store.select(getContracts);
    this.initializeErrorMsgKeys();
  }

  private initializeErrorMsgKeys(): void {
    this.errorMsgKeys$ = combineLatest([
      this.store.select(getSendMasterDataChangeRequestResponse),
      this.contracts$,
    ]).pipe(
      map(([response, contracts]) => {
        if (response?.changeRequestStatuses) {
          if (this.changeType !== this.MasterdataChangeType.PAYMENT) {
            const errorMsg = response?.changeRequestStatuses?.[0]?.errorMessage;
            return errorMsg ===
              MasterDataChangeRequestErrorMessages.MASTERDATA_CHANGE_REQUEST_ALREADY_EXISTS
              ? ['open_request_desc_1', 'open_request_desc_2', 'open_request_desc_3']
              : ['erp_desc_1', 'erp_desc_2'];
          } else {
            const allFailures =
              response.changeRequestStatuses.every(status => !status.success) &&
              !response.changeRequestStatuses.some(
                status =>
                  status.errorMessage ===
                  MasterDataChangeRequestErrorMessages.MASTERDATA_CHANGE_REQUEST_ALREADY_EXISTS
              );
            return allFailures
              ? ['user_payment_edit.error_desc_1', 'user_payment_edit.error_desc_2']
              : [
                  'user_payment_edit.half_error_desc_1',
                  ...getContractErrors(response, contracts, this.translateService),
                  'user_payment_edit.half_error_desc_2',
                  'user_payment_edit.half_error_desc_3',
                ];
          }
        }
        return [];
      })
    );
  }
}
